import React, { useContext } from "react";
import { t } from "i18next";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// fetch Kubernetes/ArgoCD deployment server
import ConfigContext from '../../../context/configContext';
import TagManager from "react-gtm-module";

export const HeaderSection = () => {
    const config = useContext(ConfigContext);

    return(
        <div className="transfer-phone-header">
            <div
                className="back-container"
                onClick={() => {
                    TagManager.dataLayer({
                        dataLayer: {
                          event: "porting_event",
                          event_name: "back_to_acct_overview"
                        },
                      });
                      
                    window.open(
                        `${config.ACCT_MGT_PORTING_FRONTEND}/myaccount/accountoverview`,
                        "_self"
                    );
                }}
            >
                <FontAwesomeIcon icon={faArrowLeft} />{" "}
                {t("header.back_to_account_overview")}
            </div>
            <div className="transfer-phone-header-main-text fw-bold">
                {t("transfer_phone.title")}
            </div>

        </div>
    );
};



